/**
  Description:
  still needs variables selectAll, and selected: [] in parent component
**/

export const checkAll = {
  methods: {
    checkAll (data, uniqueIdentifier = 'id') {
      this.selectAll = !this.selectAll

      if (Array.isArray(data)) {
        const check = data ? this.selected.length = data.length : false

        if (check) {
          if (this.selectAll) {
            this.selected = data.map((d) => {
              return d[uniqueIdentifier]
            })
          } else {
            this.selected = []
          }
        }
      }

      if (Object.prototype.toString.call(data) === '[object Object]') {
        if (this.selectAll) {
          const ids = Object.values(data).map(x => x[uniqueIdentifier])
          this.selected = ids
        } else {
          this.selected = []
        }
      }
    }
  }
}
